const INITIAL_STATE = {
  allTransactions: [],
  transactionsLoading: true,
};

export default INITIAL_STATE;
